"use client";
import * as React from "react";
import { OrModalProps } from "@csc-dashboard/components-library";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

/**
 * ScopedModal wraps OrModal functionality to ensure MUI portal renders within .csc-admin-panel container
 */
interface ScopedModalProps extends OrModalProps {
  className?: string;
  boxClassName?: string;
}
export const ScopedModal = ({
  open,
  onClose,
  children,
  className,
  boxClassName,
}: ScopedModalProps) => {
  const [container, setContainer] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    // Find the .csc-admin-panel container element
    const adminPanel = document.querySelector(
      ".csc-admin-panel",
    ) as HTMLElement;
    if (adminPanel) {
      setContainer(adminPanel);
    }
  }, []);

  const handleClose = () => {
    if (!onClose) {
      return;
    }
    onClose?.();
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      container={container || undefined}
      className={className}
    >
      <Fade in={open}>
        <Box
          className={`p-10 w-[496px] h-auto bg-surface-white rounded-sm shadow-mid-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 focus:outline-0 ${boxClassName}`}
        >
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};
